<app-breadcrumb></app-breadcrumb>
<div class="container" *ngIf="theme$ | async as theme">
     <div class="main-container-cache-viewer">
          <div class="category">{{category}}</div>
          <p-accordion [value]="1000" [dt]="cacheLogAccordion">
               @for (cache of cacheList; track cache.id) {
               <p-accordion-panel [value]="cache.id">
                    <p-accordion-header>
                         <span>{{ cache.key }}</span>
                    </p-accordion-header>
                    <p-accordion-content
                         [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
                         <div class="value-container">
                              <pre>
                                  {{ cache.value }}
                              </pre>
                         </div>
                    </p-accordion-content>
               </p-accordion-panel>
          }
           </p-accordion>
</div>
